exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-file-input~.custom-file-label[data-v-78071d6d]:after{content:\"Wybierz\"}", ""]);

// exports
